import React, { useEffect, useState } from 'react';
import { getAdminUsers, updateUserRole } from '../../services/adminService';

const AdminUsersPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingUserId, setUpdatingUserId] = useState(null);

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const data = await getAdminUsers();
        setUsers(data);
      } catch (error) {
        console.error('Erreur chargement utilisateurs:', error.message);
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, []);

  const handleRoleChange = async (userId, newRole) => {
    try {
      setUpdatingUserId(userId);

      const updatedUser = await updateUserRole(userId, newRole);

      setUsers((prev) =>
        prev.map((user) => (user.id === userId ? updatedUser : user))
      );
    } catch (error) {
      console.error('Erreur mise à jour rôle:', error.message);
    } finally {
      setUpdatingUserId(null);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 pt-32 pb-10">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-[#2A2A2A]">Gestion des utilisateurs</h1>
        <p className="text-[#6B6B6B] mt-2">
          Consulte les membres et gère les rôles administrateur.
        </p>
      </div>

      <div className="bg-white border border-[#E6E1D6] rounded-2xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-[#FFFCF8]">
              <tr>
                <th className="px-4 py-3 text-sm font-semibold text-[#2A2A2A]">Nom</th>
                <th className="px-4 py-3 text-sm font-semibold text-[#2A2A2A]">Email</th>
                <th className="px-4 py-3 text-sm font-semibold text-[#2A2A2A]">Téléphone</th>
                <th className="px-4 py-3 text-sm font-semibold text-[#2A2A2A]">Rôle</th>
                <th className="px-4 py-3 text-sm font-semibold text-[#2A2A2A]">Statut</th>
                <th className="px-4 py-3 text-sm font-semibold text-[#2A2A2A]">Actions</th>
              </tr>
            </thead>
            <tbody>
              {!loading &&
                users.map((user) => (
                  <tr key={user.id} className="border-t border-[#E6E1D6]">
                    <td className="px-4 py-4 text-[#2A2A2A]">
                      {[user.first_name, user.last_name].filter(Boolean).join(' ') || '—'}
                    </td>
                    <td className="px-4 py-4 text-[#2A2A2A]">{user.email || '—'}</td>
                    <td className="px-4 py-4 text-[#2A2A2A]">{user.phone || '—'}</td>
                    <td className="px-4 py-4 text-[#2A2A2A]">{user.role || 'client'}</td>
                    <td className="px-4 py-4 text-[#2A2A2A]">
                      {user.is_active ? 'Actif' : 'Inactif'}
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleRoleChange(user.id, 'admin')}
                          disabled={updatingUserId === user.id || user.role === 'admin'}
                          className="px-3 py-2 rounded-lg border border-[#E6E1D6] hover:bg-[#FFFCF8] transition disabled:opacity-50"
                        >
                          Passer admin
                        </button>
                        <button
                          onClick={() => handleRoleChange(user.id, 'client')}
                          disabled={updatingUserId === user.id || user.role === 'client'}
                          className="px-3 py-2 rounded-lg border border-[#E6E1D6] hover:bg-[#FFFCF8] transition disabled:opacity-50"
                        >
                          Retirer admin
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {loading && (
          <div className="p-6 text-[#6B6B6B]">Chargement des utilisateurs...</div>
        )}

        {!loading && users.length === 0 && (
          <div className="p-6 text-[#6B6B6B]">Aucun utilisateur trouvé.</div>
        )}
      </div>
    </div>
  );
};

export default AdminUsersPage;